var _defs, _g, _filter;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwotimer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 386 176",
    role: "img",
    filter: "url(#grayscale)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    lang: "en",
    id: titleId
  }, "2-timer") : title ? /*#__PURE__*/React.createElement("title", {
    lang: "en",
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M1.194 2.513H6.93c.623 0 1.132-.45 1.132-1s-.509-1-1.132-1H1.194c-.623 0-1.132.45-1.132 1s.51 1 1.132 1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M1.993 2.513h5.735c.623 0 1.132-.45 1.132-1s-.509-1-1.132-1H1.993c-.623 0-1.133.45-1.133 1s.51 1 1.133 1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#BE3D6F",
    d: "M322.38 114.943s6.826-43.794 38.748-51.239c31.853 46.112-14.043 77-14.043 77l-24.705-25.761"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M360.71 63.704c.109.162.214.323.321.484l-20.503 48.365L371.38 102.5a48.87 48.87 0 0 1-.159 1.081l-31.2 10.167-5.916 13.956-.725-.773 11.794-27.821-10.237-15.956c.194-.294.39-.588.59-.881l10.107 15.753 14.484-34.168c.198-.05.392-.106.591-.154"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EF6874",
    d: "M329.26 93.133a6.5 6.5 0 1 1 6.481-11.267 6.5 6.5 0 0 1-6.482 11.267zm19.56 1.215c-.054-.396-1.19-1.427-2.66-2.308.384-1.426.548-2.881.505-4.321 1.46-.333 2.966-.837 3.226-1.531.528-1.41-1-5.207-1.508-5.593-.325-.246-1.908-.164-3.604.273a14.907 14.907 0 0 0-2.615-3.426c.8-1.27 1.513-2.698 1.205-3.374-.623-1.37-4.389-2.974-5.02-2.888-.396.053-1.421 1.183-2.3 2.646a14.88 14.88 0 0 0-4.367-.648c-.333-1.41-.825-2.818-1.494-3.069-1.41-.528-5.206 1-5.592 1.508-.23.302-.175 1.692.185 3.25a14.91 14.91 0 0 0-3.723 2.733c-1.164-.696-2.381-1.246-2.99-.97-1.37.624-2.974 4.389-2.888 5.021.048.356.966 1.22 2.214 2.03a14.892 14.892 0 0 0-.684 4.754c-1.24.327-2.377.782-2.6 1.377-.529 1.41 1 5.206 1.507 5.592.28.213 1.49.18 2.902-.11a14.881 14.881 0 0 0 2.971 3.834c-.642 1.106-1.121 2.227-.86 2.804.624 1.37 4.39 2.974 5.021 2.888.357-.049 1.225-.971 2.036-2.223a14.9 14.9 0 0 0 4.704.522c.33 1.305.799 2.539 1.421 2.772 1.41.528 5.207-1 5.592-1.508.231-.304.174-1.707-.19-3.274a14.87 14.87 0 0 0 3.523-2.834c1.223.753 2.55 1.387 3.195 1.094 1.37-.623 2.974-4.389 2.888-5.02z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFE",
    d: "M335.99 81.13c-3.824-2.337-8.726-.933-10.926 3.13-2.2 4.064-.878 9.272 2.946 11.61 3.824 2.337 8.726.933 10.926-3.13 2.2-4.064.878-9.272-2.946-11.61zM86.85 88.906a4.064 4.064 0 0 1-.15-.119 14.356 14.356 0 0 1-1.192 2.817c-3.754 6.743-12.117 9.073-18.642 5.194-4.273-2.54-6.714-7.122-6.837-11.875h-.002a2.634 2.634 0 0 1-.177-.066c.103 4.84 2.578 9.514 6.927 12.1 6.61 3.929 15.082 1.57 18.885-5.261a14.54 14.54 0 0 0 1.188-2.79"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9E206C",
    d: "M68.85 103.731s-2.6-39.723-30.316-48.874c-31.877 38.78 6.38 70 6.38 70l23.936-21.126"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFE",
    d: "M38.373 54.857c-.11.135-.216.27-.324.405L52.586 99.88 25.85 88.498c.016.327.036.65.058.974l27.036 11.51 4.195 12.875.707-.63-8.362-25.666L59.85 74.19a57.13 57.13 0 0 0-.457-.83l-10.235 13.2-10.27-31.52c-.172-.061-.34-.126-.515-.184"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DF5973",
    d: "M26.142 78.822c-7.429-2.737-15.627-3.994-23.857-1.96-8.814 32.074 25.852 47.237 25.852 47.237l34.713.758-1.9-7.314c-4.601-17.71-17.485-32.34-34.808-38.721"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M32.696 81.903l-1.69 17.288L2.575 76.857c-.217.049-.432.093-.649.146-.034.126-.063.249-.096.375l15.229 11.961L.85 92.124c.023.152.05.302.075.452l.071.399 16.975-2.918L43.35 109.99l-28.285 5.778c.283.24.564.478.846.708l28.33-5.787 18.02 14.155.59.012-.216-.824-30.807-24.197 1.71-17.503a76.21 76.21 0 0 0-.84-.43"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BE3D6F",
    d: "M53.271 118.156s-32.225-7.027-44.42 11.612c18.967 41.393 72 19.089 72 19.089l-27.58-30.701"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M8.85 129.16c.074.159.15.314.223.472l44.35 6.089-17.648 16.87c.328.092.656.181.985.266l17.768-16.984 17.322 2.378-.9-1.007-33.725-4.631-11.28-14.756c-.305.079-.609.16-.912.246l10.964 14.341-26.869-3.689c-.092.134-.187.266-.278.403v.002"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9E206C",
    d: "M324.38 126.928s29.954-32.919 60.975-22.007c1.37 55.61-54.385 56.783-54.385 56.783l-6.59-34.776"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFE",
    d: "M385.37 104.899c.005.194.007.384.01.577l-44.015 28.935 31.878 8.482c-.24.275-.483.544-.728.811l-32.238-8.577-12.702 8.35-.195-1.038 25.32-16.644h-.001l-.013-18.815c.327-.139.656-.276.987-.41l.012 18.576 31.096-20.442c.196.066.393.126.59.195M258.037 88.04a4.453 4.453 0 1 1 4.764-7.526 4.453 4.453 0 0 1-4.764 7.525"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B2441",
    d: "M298.325 110.704l6.958-17.092c.266-.653-.035-1.374-.671-1.611l-3.275-1.22c-.637-.238-1.368.098-1.634.75l-6.323 18.08c1.647.382 3.294.753 4.945 1.093"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005C5A",
    d: "M294.788 110.704c3.186-9.578 6.537-19.571 6.592-19.964-.596-.152-1.238.19-1.483.821l-7.517 18.556c.802.199 1.605.394 2.408.587"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF7676",
    d: "M192.107 71.09l16.352-.09s-1.246-4.972-.779-8.792c.177-1.444 1.051-2.72 2.285-3.491C225.99 48.697 222.06 37.25 222.06 37.25s-1.743-14.531-22.343-15.828c-21.961-1.382-20.542 18.125-20.542 18.125s-.943 10.863 10.488 18.174c1.636 1.047 2.674 2.811 2.921 4.737.618 4.836-.478 8.63-.478 8.63"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B0306E",
    d: "M208.459 70.961l.032 5.857c.011 2.195-1.413 3.998-3.165 4.007l-9.956.055c-1.753.01-3.196-1.779-3.208-3.973l-.032-5.857 16.329-.089"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9E206C",
    d: "M204.297 80.831l-1.111 2.682-6.192.034-1.369-2.669 8.672-.047"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFE",
    d: "M207.452 44.788c-1.256 1.877-3.266 2.414-5.348 2.247l-.018-3.567a2.468 2.468 0 0 1 .719-1.77c.839-.835 2.334-1.718 4.192-.79 1.17.721 1.31 2.604.455 3.88zm-10.077 1.18c-1.577-.515-3.81-1.57-4.025-3.139-.053-.384.114-.777.4-1.037 2.754-2.492 3.586 1.974 3.574 2.533.06.54.058 1.093.05 1.643zm11.033-.995c2.461-4.643-3.665-6.906-6.54-3.72-.52.576-.751 1.356-.763 2.133-.02 1.375.012 3.517.012 3.517a24.488 24.488 0 0 1-2.568-.58c.03-1.327.008-2.7-.383-3.84-1.73-5.066-8.228-1.108-4.415 2.5.893.844 2.205 1.473 3.62 1.925l.335 24.064 1.117-.007-.206-14.79-.107-7.675c-.005-.402.005-.83.016-1.267a19.24 19.24 0 0 0 2.465.43l.126 23.29 1.117-.006-.126-23.202c.226.01.458.023.668.021 2.124-.016 4.572-.794 5.632-2.793z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EF6874",
    d: "M178.78 17.548a.863.863 0 0 0-.006-1.223l-8.3-8.211a.865.865 0 1 0-1.217 1.23l8.301 8.21a.864.864 0 0 0 1.223-.006m36.444-.198a.863.863 0 0 1-.006-1.222l8.21-8.301a.865.865 0 1 1 1.23 1.216l-8.21 8.3a.865.865 0 0 1-1.224.007M199.6 14.405a.864.864 0 0 0 .86-.87l-.064-11.675a.864.864 0 1 0-1.73.01l.064 11.675a.864.864 0 0 0 .87.86"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D4D4D4",
    d: "M36.85 89.857h101.458l25.542 83H60.264l-23.414-83"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6D6D6D",
    d: "M42.85 92.857h92.67l23.33 76H64.236l-21.386-76"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E0E0E0",
    d: "M189.206 175.857H62.496c-1.455 0-2.646-1.12-2.646-2.489v-2.022c0-1.369 1.19-2.489 2.645-2.489h126.71c1.455 0 2.645 1.12 2.645 2.489v2.022c0 1.37-1.19 2.49-2.644 2.49"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D4D4D4",
    d: "M105.994 175.857H61.467c-.89 0-1.617-.68-1.617-1.511v-3.977c0-.831.728-1.512 1.617-1.512h44.527c1.571 0 2.856 1.202 2.856 2.672v1.657c0 1.47-1.285 2.671-2.856 2.671"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M153.85 171.857a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-6 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-53.132 1h-5.736c-.622 0-1.132-.45-1.132-1s.51-1 1.132-1h5.736c.623 0 1.132.45 1.132 1s-.51 1-1.132 1m-10 0h-5.736c-.623 0-1.132-.45-1.132-1s.51-1 1.132-1h5.736c.623 0 1.132.45 1.132 1s-.509 1-1.132 1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D4D4D4",
    d: "M362.38 90.704H261.721l-25.341 82h102.77l23.23-82"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6D6D6D",
    d: "M357.38 92.704h-92.67l-23.33 76h94.615l21.385-76"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E0E0E0",
    d: "M211.005 175.704h125.75c1.444 0 2.625-1.12 2.625-2.489v-2.022c0-1.369-1.18-2.489-2.625-2.489h-125.75c-1.444 0-2.625 1.12-2.625 2.489v2.022c0 1.369 1.181 2.49 2.625 2.49"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D4D4D4",
    d: "M294.178 175.704h43.62c.87 0 1.582-.68 1.582-1.511v-3.977c0-.832-.712-1.512-1.583-1.512h-43.62c-1.538 0-2.797 1.202-2.797 2.671v1.658c0 1.469 1.259 2.671 2.798 2.671"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M246.38 171.704a1 1 0 1 0 2 0 1 1 0 0 0-2 0m6 0a1 1 0 1 0 2.001 0 1 1 0 0 0-2.001 0"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(304.318 170.191)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M1.194 2.513H6.93c.623 0 1.132-.45 1.132-1s-.509-1-1.132-1H1.194c-.623 0-1.132.45-1.132 1s.51 1 1.132 1",
    mask: "url(#b)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(313.52 170.191)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M1.993 2.513h5.735c.623 0 1.132-.45 1.132-1s-.509-1-1.132-1H1.993c-.623 0-1.133.45-1.133 1s.51 1 1.133 1",
    mask: "url(#d)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F0AB85",
    d: "M143.223 104.833s.345 41.343 11.124 40.85c10.779-.49 17.875-33.132 17.875-33.132l-4.367-1.281-10.46 19.745s1.57-6.434-1.085-18.276c-2.655-11.842-13.087-7.906-13.087-7.906"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0AB85",
    d: "M167.661 112.033l-1.933-7.87s1.459-3.853 3.21-5.132c.527-.386 1.246-.382 1.792-.025 1.267.827 4.18 2.796 4.562 3.647.19.421.137.916-.08 1.323l-1.562 3.013-1.428 5.562-4.561-.518"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BE3D6F",
    d: "M133.473 94.475c7.615 0 9.399 1.115 9.399 1.115s9.763 12.102 13.163 19.929c1.271 2.926 1.294 6.272-.05 9.167-5.996 12.923-5.233 37.805-5.233 37.805h-22.245c.986-18.546-18.154-64.496 4.966-68.016"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2B2B2B",
    d: "M151.238 168.443l-.486-5.952h-9.412l-5.012 5.952h14.91"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EC967C",
    d: "M143.996 89.25l.02 14.59-8.76-9.547.945-13.582 7.795 8.538"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2B2B2B",
    d: "M145.455 67.93c-6.068.824-9.086 8.601-9.086 8.601l.069 23.017-10.52-9.096s-.763-10.385 1.832-21.698c2.25-7.126 11.33-9.002 17.705-5.526 3.1 1.69 4.942 5.008 6.036 8.303 1.47 4.423 1.598 9.183.624 13.741l-3.608 16.889-4.491-4.453s-1.152-4.31-.02-8.459c2.311-8.477 5.531-21.873 1.459-21.32"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0AB85",
    d: "M134.583 76.853c.68-.658 1.953-.533 2.843.279.89.812 1.06 2.004.38 2.662-.68.658-1.953.534-2.843-.278-.89-.812-1.06-2.004-.38-2.663"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0AB85",
    d: "M146.526 89.445c1.175-.036 2.264-.229 2.834-.737 3.387-5.4-.471-19.954-.471-19.954l-5.416-2.5-6.88 4.704-.392 9.753a8.19 8.19 0 0 0 3.072 6.729c2.18 1.34 4.696 2.082 7.253 2.005"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2B2B2B",
    d: "M146.6 67.133c1.297 4.35-10.23 9.398-10.23 9.398l-2.897-5.43 5.292-6.487 6.69 1.069s.922.725 1.144 1.45"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B2441",
    d: "M146.673 68.049c.241 1.716 2.917 3.798 2.917 3.798l.252-2.052-.61-1.441-1.374-.763s-1.427-1.259-1.185.458"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#343434",
    d: "M147.98 168.443c.244-2.21.417-4.208.51-5.952h-19.983s-3.08 1.292-6.331 5.952h25.805"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0AB85",
    d: "M195.864 137.688c.37.18 1.696.676 4.483.22 2.5-.41 7.416-2.885 7.086-.048-1.995 1.953-4.109 4.507-4.109 4.507-1.32 1.051-4.142 1.036-5.909.672l-5.325-1.807s-1.096-2.64-1.169-2.756l.928-.724c1.349.205 2.703.171 4.015-.064"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0AB85",
    d: "M196.996 138.624s.114.106.352.243c-.288.224-.562.46-.825.706-1.271.366-2.53.773-3.796 1.154-.124-.81-.3-1.947-.327-2.025l7.776-4.253s.914.763-.348 2.162a8.4 8.4 0 0 1-2.832 2.013"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0AB85",
    d: "M126.234 102.756c7.966-8.212 23.155 12.1 28.607 18.086a11.55 11.55 0 0 0 3.584 2.653l36.424 14.172-2.289 3.765-40.164-8.605a15.652 15.652 0 0 1-4.426-1.976c-7.591-4.92-29.67-19.914-21.736-28.095"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EC967C",
    d: "M153.458 132.267l17.958 3.804-.364.726-17.765-3.763a16.065 16.065 0 0 1-4.624-1.818c-4.06-2.377-10.515-7.235-16.38-12.043.2-.184.397-.372.591-.563 6.167 5.037 12.949 10.03 16.187 11.927a15.26 15.26 0 0 0 4.397 1.73"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0AB85",
    d: "M256.533 104.688s-.345 41.342-11.124 40.85c-10.779-.491-17.875-33.132-17.875-33.132l4.367-1.282 10.46 19.745s-1.57-6.434 1.085-18.276c2.655-11.842 13.087-7.905 13.087-7.905"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0AB85",
    d: "M232.095 111.888l1.934-7.871s-1.46-3.853-3.21-5.132c-.528-.386-1.247-.381-1.793-.024-1.267.827-4.18 2.795-4.562 3.647-.19.42-.137.915.081 1.322l1.561 3.013 1.428 5.563 4.561-.518"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BE3D6F",
    d: "M266.283 94.33c-7.615 0-9.399 1.114-9.399 1.114s-9.763 12.103-13.163 19.93c-1.271 2.926-1.294 6.272.05 9.167 5.996 12.922 5.233 37.804 5.233 37.804h22.245c-.986-18.545 18.154-64.495-4.966-68.016"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2B2B2B",
    d: "M248.519 168.297l.485-5.952h9.412l5.012 5.952h-14.91"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EC967C",
    d: "M255.76 89.104l-.02 14.591 8.76-9.548-.945-13.581-7.794 8.538"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2B2B2B",
    d: "M254.301 67.783c6.068.825 9.086 8.602 9.086 8.602l-.068 23.017 10.52-9.095s.762-10.386-1.832-21.699c-2.252-7.125-11.33-9.001-17.706-5.525-3.1 1.69-4.942 5.007-6.036 8.302-1.47 4.423-1.598 9.183-.624 13.741l3.608 16.89 4.491-4.453s1.152-4.31.02-8.46c-2.311-8.477-5.531-21.873-1.459-21.32"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0AB85",
    d: "M265.173 76.707c-.68-.657-1.953-.533-2.843.28-.89.811-1.06 2.004-.38 2.661.68.659 1.953.534 2.843-.278.89-.812 1.06-2.004.38-2.663"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0AB85",
    d: "M253.23 89.299c-1.175-.035-2.264-.228-2.834-.737-3.387-5.399.471-19.954.471-19.954l5.416-2.499 6.88 4.703.392 9.754a8.19 8.19 0 0 1-3.072 6.728c-2.18 1.34-4.696 2.082-7.253 2.005"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2B2B2B",
    d: "M253.157 66.987c-1.297 4.35 10.23 9.398 10.23 9.398l2.896-5.429-5.292-6.487-6.69 1.068s-.922.725-1.144 1.45"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B2441",
    d: "M253.083 67.903c-.241 1.716-2.917 3.798-2.917 3.798l-.252-2.051.61-1.442 1.374-.763s1.427-1.258 1.185.458"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#343434",
    d: "M251.775 168.297c-.242-2.21-.416-4.207-.51-5.952h19.984s3.08 1.293 6.331 5.952h-25.805"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0AB85",
    d: "M273.522 102.61c-7.966-8.212-23.155 12.1-28.607 18.086a11.55 11.55 0 0 1-3.584 2.654l-36.424 14.171 2.289 3.765 40.164-8.604a15.652 15.652 0 0 0 4.426-1.976c7.591-4.92 29.67-19.914 21.736-28.095"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EC967C",
    d: "M246.298 132.121l-17.958 3.805.364.725 17.765-3.762a16.065 16.065 0 0 0 4.624-1.819c4.06-2.377 10.515-7.235 16.38-12.042-.2-.185-.397-.373-.591-.564-6.167 5.037-12.949 10.03-16.187 11.927a15.26 15.26 0 0 1-4.397 1.73"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0AB85",
    d: "M205.551 138.248c-.328.247-1.54.992-4.478 1.223-2.638.208-8.255-.877-7.183 1.58 2.525 1.285 5.327 3.079 5.327 3.079 1.61.636 4.46-.025 6.153-.753l4.92-2.83s.422-2.608.466-2.727l-1.127-.434c-1.31.493-2.69.772-4.078.862"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0AB85",
    d: "M203.06 137.463s-.083.124-.281.306c.338.137.664.29.983.453 1.332.036 2.662.114 3.994.164-.081-.772-.194-1.854-.19-1.932l-8.655-2.068s-.701.914.881 1.9a8.81 8.81 0 0 0 3.269 1.177"
  }))), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "grayscale"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwotimer);
export default __webpack_public_path__ + "static/media/twotimer.96abd36e88b3d1bebcd9aaef600483d0.svg";
export { ForwardRef as ReactComponent };